import Error from '../model/Error';
import axios from 'axios';

export default class ChildAvatarsRepository {
    static findByKindergarten(kindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/kindergartens/${kindergartenId}/child-avatars`)
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)))
            ;
        });
    }

    static update(kindergartenId, { childAvatarSet = 'default' } = {}) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/kindergartens/${kindergartenId}/child-avatars`, { childAvatarSet })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
